import { render, staticRenderFns } from "./ServiceGroups.vue?vue&type=template&id=6c621efc&"
import script from "./ServiceGroups.vue?vue&type=script&lang=js&"
export * from "./ServiceGroups.vue?vue&type=script&lang=js&"
import style0 from "./ServiceGroups.vue?vue&type=style&index=0&id=6c621efc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports